import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SharePointOnlineListResourceDataset } from 'app/model/dataset/sharepoint-online-list-resource.dataset';
import { TabularCopySource } from './tabular-type.copysource';

import { IAttribute } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.sharePointOnlineList.copySourceType,
    display: [],
    tags: {
        datasetModel: Metamodel.modelFor(SharePointOnlineListResourceDataset)
    }
})
export class SharePointOnlineListCopySource extends TabularCopySource {
    public static readonly HTTP_REQUEST_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'HTTP_REQUEST_TIMEOUT',
        display: stringResources.ModelName_Request_Timeout
    })
    public httpRequestTimeout?: string = '00:05:00';
}
